import DataFetcher from "../../hooks/DataFetcherPosgrados";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import { NavLink } from "react-router-dom";
import Breadcumbs from "../../components/Breadcumbs";
import Block6Columns from "../../components/Block6Columns";
import Quote from "../../components/Quote";
import Modalidad from "../../components/posgrados/Modalidad";
import Duracion from "../../components/posgrados/Duracion";
import Campo from "../../components/posgrados/Campo";
import calendario from "../../img/iconsoferta/calendario.png";
import modalidad from "../../img/iconsoferta/modalidad.png";
import titulo from "../../img/iconsoferta/titulo.png";
import sale from "../../img/iconsoferta/sale.png";
import campo from "../../img/iconsoferta/campo.png";
import inicio from "../../img/iconsoferta/inicio.png";
import {
  NormativaPosgrados,
  PosgradoPostulacionFixed,
} from "../../components/Pasos";
import Brochure from "../../components/posgrados/Brochure";
import Accordion from "../../components/Accordion";
import BlockLeftImage from "../../components/BlockLeftImage";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/posgrado/eee8f913-489e-4501-b3c7-9d964fdbfc33" +
  "?include=field_imagen_portada.field_media_image,field_imagen_requisitos.field_media_image,field_imagen_perfil_de_egreso.field_media_image" +
  "&fields[node--posgrados]=title,field_titulo,field_modalidad,field_precio," +
  "field_campo_amplio,field_duracion,field_inicio_clases,field_resolucion," +
  "field_perfil_de_ingreso,field_atributo_1,field_atributo_2,field_atributo_3," +
  "field_imagen_portada,field_imagen_requisitos,field_requisitos_de_postulacion,field_malla_curricular,field_imagen_perfil_de_egreso,field_texto_portada,field_publicado,field_enlace_postulacion" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

export default function MaestriaFinanzas() {
  const DataDisplay = ({ data }) => (
    <div>
      <BlockImageCabecera
        src={data.imagen_portada}
        title={
          <>
            {" "}
            <div
              dangerouslySetInnerHTML={{
                __html: data.field_texto_portada?.processed ?? "",
              }}
            />
            {data.field_publicado && (
              <>
                <PosgradoPostulacionFixed></PosgradoPostulacionFixed>
                <a
                  href={data.field_enlace_postulacion?.uri}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {data.field_enlace_postulacion?.title || "Postular"}
                </a>
              </>
            )}
          </>
        }
      />
      <div className="graybg">
        <Breadcumbs
          content={
            <>
              <NavLink to="/escuela-negocios">Posgrados</NavLink>
              <span class="material-icons">chevron_right</span>
              <NavLink to="/maestria-finanzas">Maestría en Finanzas</NavLink>
            </>
          }
        ></Breadcumbs>
        <div className="padding oferta-icons">
          <Block6Columns
            col1={
              <>
                <img src={titulo}></img>
                <p>
                  <b>Título</b>
                </p>
                <p>{data.titulo_recibir}</p>
              </>
            }
            col2={
              <>
                <img src={modalidad}></img>
                <p>
                  <b>Modalidad</b>
                </p>
                <Modalidad value={data.modalidad} />
              </>
            }
            col3={
              <>
                <img src={calendario}></img>
                <p>
                  <b>Duración</b>
                </p>
                <Duracion value={data.duracion} />
              </>
            }
            col4={
              <>
                <img src={campo}></img>
                <p>
                  <b>Campo amplio</b>
                </p>
                <Campo value={data.campo} />
              </>
            }
            col5={
              <>
                <img src={sale}></img>
                <p>
                  <b>Precio</b>
                </p>
                <p>{data.precio}</p>
              </>
            }
            col6={
              <>
                <img src={inicio}></img>
                <p>
                  <b>Fecha de inicio</b>
                </p>
                <p>{data.inicio}</p>
              </>
            }
          ></Block6Columns>
        </div>
      </div>
      <div className="padding2">
        <Brochure></Brochure>
      </div>
      <div className="layout8 ">
        <div
          dangerouslySetInnerHTML={{
            __html: data.resolucion,
          }}
        />
        <div
          dangerouslySetInnerHTML={{
            __html: data.ingreso,
          }}
        />
      </div>

      <Quote
        content={
          <>
            {" "}
            <div
              dangerouslySetInnerHTML={{
                __html: data.info1,
              }}
            />
          </>
        }
      ></Quote>

      <img src={data.imagen_perfil} alt="utpl"></img>
      <div
        className="layout8 margin"
        dangerouslySetInnerHTML={{
          __html: data.egreso,
        }}
      />

      <Quote
        content={
          <>
            {" "}
            <div
              dangerouslySetInnerHTML={{
                __html: data.info2,
              }}
            />
          </>
        }
      ></Quote>

      <div className="layout6 ">
        <Accordion
          title="Más información"
          content={
            <>
              {" "}
              <div
                dangerouslySetInnerHTML={{
                  __html: data.malla,
                }}
              />
            </>
          }
        ></Accordion>
      </div>
      <div className="lightbluebg margin">
        <BlockLeftImage
          src={data.imagen_requisitos}
          content={
            <>
              <div
                className="button-nobackground"
                dangerouslySetInnerHTML={{
                  __html: data.requisitos,
                }}
              />
              {data.field_publicado && (
                <>
                  <PosgradoPostulacionFixed></PosgradoPostulacionFixed>
                  <a
                    href={data.field_enlace_postulacion?.uri}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {data.field_enlace_postulacion?.title || "Postular"}
                  </a>
                </>
              )}
            </>
          }
        ></BlockLeftImage>
      </div>

      <div dangerouslySetInnerHTML={{ __html: data.descripcion }} />
    </div>
  );

  return (
    <DataFetcher url={url}>{(data) => <DataDisplay data={data} />}</DataFetcher>
  );
}
